import React from 'react';
import { dashboardMenu, demoPages } from '../menu';
import DashboardHeader from '../pages/dashboard/DashboardHeader';
import DefaultHeader from '../pages/DefaultHeader';
import SubscriptionHeader from '../pages/subscription/SubscriptionHeader';

const headers = [
    { path: '/login', element: null, exact: true },
    { path: '/register', element: null, exact: true },
    { path: '/forgot-password', element: null, exact: true },
    { path: '/verify', element: null, exact: true },
    { path: '/404', element: null, exact: true },
    {
        path: dashboardMenu.dashboard.path,
        element: <DashboardHeader />,
        exact: true,
    },
    {
        path: demoPages.pricingTable.path,
        element: <SubscriptionHeader />,
        exact: true,
    },
    {
        path: demoPages.publishPost.path,
        element: <DashboardHeader />,
        exact: true,
    },
    {
        path: demoPages.schedulePost.path,
        element: <DashboardHeader />,
        exact: true,
    },
    {
        path: demoPages.postHistory.path,
        element: <DashboardHeader />,
        exact: true,
    },
    {
        path: '/profile',
        element: <DashboardHeader />,
        exact: true,
    },
    {
        path: `*`,
        element: <DefaultHeader />,
    },
];

export default headers;
